

export class Oauth{
    clientId:string;
    refreshToken:string;
}